export default __webpack_public_path__ + "static/media/Group 5.d2ec8fdc.png";